const error = Object.freeze({
  error1: "אוי, שעת התחלת האירוע 6 בבוקר לפחות",
  error2: "אוי, שעת סיום האירוע - 23:59 לכל המאוחר",
  error3: "אוי, משך האירוע שעה לפחות",
  error4: "אוי, משך האירוע 12 שעות לכל היותר",
  error5: "אוי, שעת סיום האירוע צריכה להיות אחרי שעת ההתחלה",
});
export { error };
